import { Component, OnInit, AfterViewInit, Input, ApplicationRef, ComponentFactoryResolver, NgZone, ElementRef, ComponentRef, Injector } from "@angular/core";
import { CityService } from '../../services/city.service';
import { iWindowComponent } from '../blocks/infoWindow/iWindow.component'
import { window } from "rxjs/operators/window";
import { DeviceDetectorService } from 'ngx-device-detector';

declare var google: any;
//declare var InfoBubble: any;
declare var $: any;

//declare var markerWithLabel : any;

//declare var markerClusterer: any
@Component({
    selector: "map",
    templateUrl: './map.component.html',
    styleUrls: ["./map.component.scss"]
})
export class MapComponent implements OnInit, AfterViewInit {
    @Input() model: any;
    @Input() selectedTab: number;
    compRef: ComponentRef<iWindowComponent>;
    filteredCities: any;
    //markerWithLabel: any;
    relativePixelSize: number;
    //infoBubble = new InfoBubble();
    infoWindow = new google.maps.InfoWindow();
    zoomLevel = 0;
    public markers: Array<any>;
    public textMarkers: Array<any> = [];
    public map: any;
    public cities: Array<any>;
    customMapTypeId = 'custom_style';
    cityObj: any;
    deviceInfo = null;
    public customMapType = new google.maps.StyledMapType([
        {
            stylers: [
                { 'saturation': -100 },
                { 'lightness': 50 },
                { 'visibility': 'simplified' }
            ]
        },
        {
            elementType: 'labels',
            stylers: [{ visibility: 'off' }]
        },
        {
            featureType: 'road',
            stylers: [{ color: '#bbb' }]
        }
    ], {
            name: 'Israel'
        });




    public initMap(wnd: any) {
        let clusterStyles = [
            {
                textColor: 'white',
                url: 'path/to/smallclusterimage.png',
                height: 50,
                width: 50
            },
            {
                textColor: 'white',
                url: 'path/to/mediumclusterimage.png',
                height: 50,
                width: 50
            },
            {
                textColor: 'white',
                url: 'path/to/largeclusterimage.png',
                height: 50,
                width: 50
            }
        ];

        var mcOptions = {
            gridSize: 50,
            styles: clusterStyles,
            maxZoom: 15
        }

        this.markers = [];
        var mapProp = {
            //center: new google.maps.LatLng(32.708765, 35.503778),
            zoomControl: true,
            //scaleControl: true,
            streetViewControl: false,
            minZoom: 10, maxZoom: 15,
            gestureHandling: 'greedy',
            //zoom: 10,
            mapTypeControl: false,
            fullscreenControl: false,
            disableDefaultUI: false, // a way to quickly hide all controls
            //mapTypeControlOptions: {
            //  mapTypeIds: [google.maps.MapTypeId.ROADMAP, google.maps.MapTypeId.HYBRID]
            //},
        };
        this.map = new google.maps.Map(document.getElementById("map"), mapProp);
        this.map.mapTypes.set(this.customMapTypeId, this.customMapType);
        this.map.setMapTypeId(this.customMapTypeId);
        //markerClusterer = new MarkerClusterer(this.map,[],{imagePath: '../assets/images/m'});
        //debugger;
        var self = this;
        //alert(self);
        //this.map.addListener('zoom_changed',/*function(){ wnd.initMarkers()}, false);*/ function (self) {

        //debugger;
        this.map.addListener('zoom_changed', function () { wnd.updateMarkers(this.getZoom()) }, function () {
            //console.log(self);
            // this.zoomLevel = this.getZoom();

            //console.log(this.zoomLevel)
        });


    }
    
    updateMarkers(zoom) {
        //alert(zoom);
        this.zoomLevel = zoom;
        //debuggerdebugger;
        /*for (let i = 0; i < this.markers.length; i++) {
            //console.log(this.markers[i])
            let marker = this.markers[i];

            if (marker.isText) {

                if (zoom >= marker.zoom) {
                    marker.setLabel(marker.name);
                    //marker.seti
                }

                else {
                    marker.setLabel('');
                }
                //console.log(marker)
            }

            else {

                if (zoom < marker.extr.zoomScore) {
                    //marker.setLabel('');
                    //find the city. and by the zoom set icon size 
                }
            }
        }*/
        this.clearTextMarkers();
        this.updateMarkersByTab();
    }

    public constructor(private cityService: CityService, private injector: Injector,
        private resolver: ComponentFactoryResolver,
        private appRef: ApplicationRef,
        private zone: NgZone,private deviceService: DeviceDetectorService) {
            this.epicFunction();

        //this.markerWithLabel = new MarkerWithLabel();
        //console.log(this.markerWithLabel);
    }

    epicFunction() {
        console.log('hello `Home` component');
        this.deviceInfo = this.deviceService.getDeviceInfo();
        const isMobile = this.deviceService.isMobile();
        const isTablet = this.deviceService.isTablet();
        const isDesktopDevice = this.deviceService.isDesktop();
        console.log(this.deviceInfo);
        console.log(isMobile);  // returns if the device is a mobile device (android / iPhone / windows-phone etc)
        console.log(isTablet);  // returns if the device us a tablet (iPad etc)
        console.log(isDesktopDevice); // returns if the app is running on a Desktop browser.
      }

    public ngOnInit(): void {
        //console.log(this.markerWithLabel);
        this.initMap(this);
        this.clearMarkers();
    }



    dropMarkers(cityObj: any, tabIndex: number, index: number/*, infoWindow: any*/) {

        let image = {
            url: this.cityService.icons[cityObj.colorPlace].icon,
            // This marker is 20 pixels wide by 32 pixels high.
            size: new google.maps.Size(25, 25),
            // The origin for this image is (0, 0).
            origin: new google.maps.Point(0, 0),
            // The anchor for this image is the base of the flagpole at (0, 32).
            anchor: new google.maps.Point(32, 65),
            labelOrigin: new google.maps.Point(0, 12)///the place
        };

        let marker = new google.maps.Marker({
            isText: false,
            extr: cityObj,
            position: new google.maps.LatLng(cityObj.Lat, cityObj.Lng),
            map: this.map,
            clickable: true,
            labelAnchor: new google.maps.Point(0, 0),
            label: {
                text: ' ',//cityObj.value,
                color: 'white',
                fontSize: "10px",
                fontWeight: "bold",
                fontFamily: 'Open Sans Hebrew'
            },
        });


        if (this.deviceService.isDesktop()) {
            marker.addListener('mouseover', (e) => {
                // we need to run it in angular2 zone
                this.zone.run(() => this.onMarkerClick(marker, e));
            });
        }
       else if (this.deviceService.isTablet()) {
            marker.addListener('click', (e) => {
                // we need to run it in angular2 zone
                this.zone.run(() => this.onMarkerClick(marker, e));
            });
        }

        this.markers.push(marker);
        //this.markers.push(markerText);
    }

    onMarkerClick(marker, e) {

        // debugger;

        if (this.compRef) this.compRef.destroy();

        const compFactory = this.resolver.resolveComponentFactory(iWindowComponent);
        this.compRef = compFactory.create(this.injector);
        //marker.extr.tabIndex= this.this.selectedTab;
        this.compRef.instance.place = marker.extr;
        this.appRef.attachView(this.compRef.hostView);


        let div = document.createElement('div');
        div.appendChild(this.compRef.location.nativeElement);

        var options = {
            map: this.map,
            content: div,
            position: marker.position,
            shadowStyle: 1,
            padding: 0,
            backgroundColor: 'rgb(57,57,57)',
            borderRadius: 4,
            arrowSize: 0,
            borderWidth: 1,
            borderColor: '#2c2c2c',
            disableAutoPan: false,
            hideCloseButton: false,
            arrowPosition: 30,
            backgroundClassName: 'phoney',
            arrowStyle: 2

        }

        this.infoWindow.setContent(div);
        this.infoWindow.open(this.map, marker);
        google.maps.event.addDomListener(this.infoWindow, 'domready', function () {

            var iwOuter = $('.gm-style-iw');

            /* Since this div is in a position prior to .gm-div style-iw.
             * We use jQuery and create a iwBackground variable,
             * and took advantage of the existing reference .gm-style-iw for the previous div with .prev().
            */
            var iwBackground = iwOuter.prev();

            // Removes background shadow DIV
            iwBackground.children(':nth-child(2)').css({ 'display': 'none' });

            // Removes white background DIV
            iwBackground.children(':nth-child(4)').css({ 'background': 'rgba(255, 255, 255, 0.9)' });


            iwBackground.children(':nth-child(1)').css({ 'visibility': 'hidden' });

            // Moves the arrow 76px to the left margin.
            //iwBackground.children(':nth-child(3)').css({'visibility' : 'hidden'});

        });
    }


    ngOnDestroy() {
        if (this.compRef) {
            this.compRef.destroy();
        }
    }
    public ngAfterViewInit(): void { }
    public revealVideo(g) {
    }

    public initMarkers(/*zoom: number*/) {
        //alert('initMarkers');
        //this.zoomLevel = zoom;
        this.clearMarkers();

        this.filteredCities = this.model;
        //let bounds = new google.maps.LatLngBounds();
        var latlngbounds = new google.maps.LatLngBounds();
        //var infoWindow = new google.maps.InfoWindow();
        //alert(this.filteredCities.length);
        //alert('initMarkers');
        for (var _i = 0; _i < this.filteredCities.length; _i++) {
            // console.log(this.filteredCities[_i].lat, this.filteredCities[_i].lng);
            // if(this.filteredCities[_i].ZoomLevel <=zoom ){
            var loc = new google.maps.LatLng(this.filteredCities[_i].Lat, this.filteredCities[_i].Lng);
            //console.log(loc);
            latlngbounds.extend(loc);

            this.dropMarkers(this.filteredCities[_i], this.selectedTab, _i/*, infoWindow*/);
            // }
        }
        //this.map.fitBounds(bounds);

        //var markers = [];//some array
        //var bounds = new google.maps.LatLngBounds();
        //debugger;
        //for (var i = 0; i < this.markers.length; i++) {
        //bounds.extend(this.markers[i].position);
        //console.log(this.markers[i]);
        //}

        //if(this.markerCluster != undefined)
        //this.markerCluster.setMap(null);

        //this.markerCluster = new MarkerClusterer(this.map, this.markers,
        //  {imagePath: 'https://developers.google.com/maps/documentation/javascript/examples/markerclusterer/m'});

        this.map.fitBounds(latlngbounds);
        //this.map.panToBounds(latlngbounds);
        //this.map.setZoom(12);
    }



    ngOnChanges(changes: any) {
        //console.log(changes);
        if (changes['model']) {
            if (changes.model.currentValue) {
                // debugger;
                if (changes.selectedTab)
                    this.updateMarkersByTab();

                else {
                    //this.initMarkers(/*this.zoomLevel*/);//this.updateMarkersByTab(changes.model.currentValue, this.selectedTab);
                    this.initMarkers(/*this.zoomLevel*/);
                }
            }
        }
    }

    updateMarkersByTab() {

        for (let _index = 0; _index < this.markers.length; _index++) {

            if (this.markers[_index].isText == false) {

                let value: string;

                if (this.selectedTab == 0) {
                    value = this.markers[_index].extr.TotalValue.toString()
                }
                if (this.selectedTab == 1) {
                    value = this.markers[_index].extr.ResidentTotal.toString()
                }

                if (this.selectedTab == 3) {
                    value = this.markers[_index].extr.SiteAccessibilityTotal.toString()
                }
                if (this.selectedTab == 2) {
                    value = this.markers[_index].extr.LocalBusinessTotal.toString()
                }
                if (this.selectedTab == 4) {
                    value = this.markers[_index].extr.EngineeringTotal.toString()
                }

                
                if (this.zoomLevel >= this.markers[_index].extr.ZoomScore) {

                    this.markers[_index].label.text = value;
                }
                else {
                    this.markers[_index].label.text = " ";
                }

                //set value 
                if (this.zoomLevel <= 10 || this.zoomLevel == 11) {
                    this.markers[_index].label.fontSize = "10px";
                    this.markers[_index].label.fontWeight = "bold";
                }

                if (this.zoomLevel == 12) {
                    this.markers[_index].label.fontSize = "15px";
                    this.markers[_index].label.fontWeight = "bold";
                }
                if (this.zoomLevel > 12) {
                    this.markers[_index].label.fontSize = "18px";
                    this.markers[_index].label.fontWeight = "bold";
                }
                let place = this.cityService.getColorPlace(Number(value));
                this.markers[_index].setIcon(this.getIconByPlace(place, value));

                if (this.zoomLevel >= this.markers[_index].extr.Zoom) {
                    //create text marker with name
                    //this.markers[_index].setLabel(this.markers[_index].extr.Name);
                    this.addTextMarker(this.markers[_index]);
                }


            }
        }
    }

    addTextMarker(marker: any) {
        let imageText = {
            url: this.cityService.dotImage,
            // This marker is 20 pixels wide by 32 pixels high.
            size: new google.maps.Size(0, 0),
            // The origin for this image is (0, 0).
            origin: new google.maps.Point(0, 0),
            // The anchor for this image is the base of the flagpole at (0, 32).
            anchor: new google.maps.Point(32, 65),
            labelOrigin: new google.maps.Point(-5, 30)///the place
        };

        let markerText = new google.maps.Marker({
            isText: true,
            name: marker.extr.Name,
            extr: marker.extr,
            position: marker.position,
            map: this.map,
            icon: imageText,
            label: {
                text: marker.extr.Name,
                color: 'black',
                fontSize: '',
                fontWeight: '',
                fontFamily: 'Open Sans Hebrew'
            }
        });

        if (this.zoomLevel == 10) {
            markerText.label.fontSize = "10px";
            markerText.label.fontWeight = "bold";

            if (marker.extr.Name.length == 3)
                markerText.icon.labelOrigin = new google.maps.Point(2, 30);

            if (marker.extr.Name.length == 4)
                markerText.icon.labelOrigin = new google.maps.Point(-2, 30);

            if (marker.extr.Name.length == 5)
                markerText.icon.labelOrigin = new google.maps.Point(-4, 30);

            if (marker.extr.Name.length == 6)
                markerText.icon.labelOrigin = new google.maps.Point(-6, 30);

            if (marker.extr.Name.length == 7)
                markerText.icon.labelOrigin = new google.maps.Point(-6, 30);

            if (marker.extr.Name.length == 8)
                markerText.icon.labelOrigin = new google.maps.Point(-6, 30);

            if (marker.extr.Name.length == 9)
                markerText.icon.labelOrigin = new google.maps.Point(-9, 30);

            if (marker.extr.Name.length == 10)
                markerText.icon.labelOrigin = new google.maps.Point(-9, 30);

            if (marker.extr.Name.length ==11)
                markerText.icon.labelOrigin = new google.maps.Point(-10, 30);

            if (marker.extr.Name.length ==12)
                markerText.icon.labelOrigin = new google.maps.Point(-10, 30);

            if (marker.extr.Name.length > 12 && marker.extr.Name.length <= 20)
                markerText.icon.labelOrigin = new google.maps.Point(-22, 30);
        }

        if (this.zoomLevel == 11) {
            markerText.label.fontSize = "10px";
            markerText.label.fontWeight = "bold";

            if (marker.extr.Name.length == 3)
                markerText.icon.labelOrigin = new google.maps.Point(2, 30);

            if (marker.extr.Name.length == 4)
                markerText.icon.labelOrigin = new google.maps.Point(0, 30);

            if (marker.extr.Name.length == 5)
                markerText.icon.labelOrigin = new google.maps.Point(-3, 30);

            if (marker.extr.Name.length == 6)
                markerText.icon.labelOrigin = new google.maps.Point(-6, 30);

            if (marker.extr.Name.length == 7)
                markerText.icon.labelOrigin = new google.maps.Point(-6, 30);

            if (marker.extr.Name.length == 8)
                markerText.icon.labelOrigin = new google.maps.Point(-6, 30);

            if (marker.extr.Name.length == 9)
                markerText.icon.labelOrigin = new google.maps.Point(-9, 30);

            if (marker.extr.Name.length == 10)
                markerText.icon.labelOrigin = new google.maps.Point(-9, 30);

            if (marker.extr.Name.length == 11)
                markerText.icon.labelOrigin = new google.maps.Point(-10, 30);

            if (marker.extr.Name.length == 12)
                markerText.icon.labelOrigin = new google.maps.Point(-14, 30);

            if (marker.extr.Name.length > 12 )
                markerText.icon.labelOrigin = new google.maps.Point(-25, 30);

        }


        if (this.zoomLevel == 12) {
            markerText.label.fontSize = "15px";
            markerText.label.fontWeight = "bold";

            if (marker.extr.Name.length == 3)
                markerText.icon.labelOrigin = new google.maps.Point(5, 45);

            if (marker.extr.Name.length == 4)
                markerText.icon.labelOrigin = new google.maps.Point(-2, 45);

            if (marker.extr.Name.length == 5)
                markerText.icon.labelOrigin = new google.maps.Point(-4, 45);

            if (marker.extr.Name.length == 6)
                markerText.icon.labelOrigin = new google.maps.Point(-6, 45);

            if (marker.extr.Name.length == 7)
                markerText.icon.labelOrigin = new google.maps.Point(-6, 45);

            if (marker.extr.Name.length == 8)
                markerText.icon.labelOrigin = new google.maps.Point(-6, 45);

            if (marker.extr.Name.length == 9)
                markerText.icon.labelOrigin = new google.maps.Point(-9, 45);

            if (marker.extr.Name.length == 10)
                markerText.icon.labelOrigin = new google.maps.Point(-20, 45);

            if (marker.extr.Name.length == 11)
                markerText.icon.labelOrigin = new google.maps.Point(-22, 45);

            if (marker.extr.Name.length == 12)
                markerText.icon.labelOrigin = new google.maps.Point(-22, 45);

            if (marker.extr.Name.length > 12)
                markerText.icon.labelOrigin = new google.maps.Point(-40, 45);
        }


        if (this.zoomLevel > 12) {
            markerText.label.fontSize = "18px";
            markerText.label.fontWeight = "bold";

            if (marker.extr.Name.length == 3)
                markerText.icon.labelOrigin = new google.maps.Point(7, 65);

            if (marker.extr.Name.length == 4)
                markerText.icon.labelOrigin = new google.maps.Point(3, 65);

            if (marker.extr.Name.length == 5)
                markerText.icon.labelOrigin = new google.maps.Point(3, 65);

            if (marker.extr.Name.length == 6)
                markerText.icon.labelOrigin = new google.maps.Point(3, 65);

            if (marker.extr.Name.length == 7)
                markerText.icon.labelOrigin = new google.maps.Point(-4, 65);

            if (marker.extr.Name.length == 8)
                markerText.icon.labelOrigin = new google.maps.Point(-8, 65);

            if (marker.extr.Name.length == 9)
                markerText.icon.labelOrigin = new google.maps.Point(-9, 65);

            if (marker.extr.Name.length == 10)
                markerText.icon.labelOrigin = new google.maps.Point(-9, 65);

            if (marker.extr.Name.length ==11)
                markerText.icon.labelOrigin = new google.maps.Point(-9, 65);

            if (marker.extr.Name.length == 12)
                markerText.icon.labelOrigin = new google.maps.Point(-20, 65);

            if (marker.extr.Name.length > 12)
                markerText.icon.labelOrigin = new google.maps.Point(-40, 65);
        }

        this.textMarkers.push(markerText);
    }

    getIconByPlace(place: number, value: string) {

        let url = this.cityService.smallMarkerURL;
        let imageSize = new google.maps.Size(10, 10);
        let labelOrigin = new google.maps.Point(5, 12);

        if (this.zoomLevel <= 7) {
            imageSize = new google.maps.Size(10, 10);
        }

        else if (this.zoomLevel == 8) {
            imageSize = new google.maps.Size(18, 18);
        }

        else if (this.zoomLevel == 9) {
            imageSize = new google.maps.Size(24, 24);
        }

        else if (this.zoomLevel == 10 || this.zoomLevel == 11) {
            imageSize = new google.maps.Size(24, 24);

            if (value.length == 1)
                labelOrigin = new google.maps.Point(8, 12)
            else if (value.length == 2)
                labelOrigin = new google.maps.Point(5, 12)
            else
                labelOrigin = new google.maps.Point(2, 12)
        }

        else if (this.zoomLevel == 12) {
            imageSize = new google.maps.Size(36, 36);

            if (value.length == 1)
                labelOrigin = new google.maps.Point(13, 18)
            else if (value.length == 2)
                labelOrigin = new google.maps.Point(8, 18)
            else
                labelOrigin = new google.maps.Point(3, 18)
        }

        else if (this.zoomLevel >= 13) {
            imageSize = new google.maps.Size(54, 59);
            url = this.cityService.largeMarkerURL;

            if (value.length == 1)
                labelOrigin = new google.maps.Point(20, 23)
            else if (value.length == 2)
                labelOrigin = new google.maps.Point(15, 23)
            else
                labelOrigin = new google.maps.Point(9, 23)
        }

        let image = {
            url: url + this.cityService.icons[place].icon,
            // This marker is 20 pixels wide by 32 pixels high.
            size: imageSize,
            // The origin for this image is (0, 0).
            origin: new google.maps.Point(0, 0),
            // The anchor for this image is the base of the flagpole at (0, 32).
            anchor: new google.maps.Point(32, 65),
            labelOrigin: labelOrigin///the place
        };
        return image;

    }
    clearMarkers = function () {

        for (var i = 0; i < this.markers.length; i++) {
            //console.log(this.markers[i])
            this.markers[i].setMap(null);
        }
        this.markers = [];
    }

    clearTextMarkers = function () {

        for (let i = 0; i < this.textMarkers.length; i++) {
            //console.log(this.markers[i])
            this.textMarkers[i].setMap(null);
        }
        this.textMarkers = [];
    }

}




// WEBPACK FOOTER //
// ./src/app/component/map/map.component.ts